import { getCategoricalLabels } from '../../../SroiGraphs/RedesignedSroiGraphs/SocialValueByStakeholders/socialValueByStakeholdersHelpers'

// Generate stakeholder data from categorical_impact array
export const generateStakeholderData = categoricalImpact => {
  if (categoricalImpact?.length) {
    // Reuse existing label generation logic to avoid code duplication
    const labels = getCategoricalLabels(categoricalImpact)

    return categoricalImpact.map((item, index) => ({
      id: `stakeholder-${index}`,
      name: labels[index],
      count: item.stakeholder_count || 0
    }))
  } else {
    return []
  }
}
